import * as React from 'react';

export const GdprTerms: React.FunctionComponent = () => (
    <span>
        I am submitting personally identifiable information about a data subject. I confirm that I
        have the data subject’s freely given, specific, informed and unambiguous consent to do so.
    </span>
);
